export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-1920w.c9fee074.png";